import {
  BLUR_IMAGE_DETECT_PROMPT,
  BLUR_IMG_MODAL,
  CROP_NOT_SUPPORTED,
  FOCUS_IMAGE_DETECT_PROMPT,
  HEALTHY_CROP,
  NOT_A_PLANT,
  ORNAMENTAL_PLANT,
  SOMETHING_WENT_WRONG,
  TOO_FAR,
  TOO_FAR_CORRECT,
  TOO_FAR_WRONG,
  UNSUPORTED_MEDIA_FILE,
} from "../assests/images";
export type ModalType =
  | "UNKNOWN_DISEASE"
  | "ORNAMENTAL"
  | "CROP_NOT_SUPPORTED"
  | "NOT_A_PLANT"
  | "IMAGE_BLURRY"
  | "TOO_FAR"
  | "UNSUPORTED_MEDIA_FILE"
  | "SOMETHING_WENT_WRONG"
  | "HEALTHY_CROP";

export interface ModalContent {
  title: string;
  description: string;
  actualText?: string;
  distortedImgText?: string;
  imgSource?: string[];
}

export const MODAL_CONFIG: Record<ModalType, ModalContent> = {
  UNKNOWN_DISEASE: {
    title: "unknown_disease_title",
    description: "unknown_disease_description",
    imgSource: [BLUR_IMG_MODAL],
  },
  ORNAMENTAL: {
    title: "ornamental_title",
    description: "ornamental_description",
    imgSource: [ORNAMENTAL_PLANT],
  },
  CROP_NOT_SUPPORTED: {
    title: "crop_not_supported_title",
    description: "crop_not_supported_description",
    imgSource: [CROP_NOT_SUPPORTED],
  },
  NOT_A_PLANT: {
    title: "not_a_plant_title",
    description: "not_a_plant_description",
    imgSource: [NOT_A_PLANT],
  },
  IMAGE_BLURRY: {
    title: "image_blurry_title",
    description: "image_blurry_description",
    imgSource: [
      BLUR_IMG_MODAL,
      FOCUS_IMAGE_DETECT_PROMPT,
      BLUR_IMAGE_DETECT_PROMPT,
    ],
    actualText: "Good focus",
    distortedImgText: "Too Blurry",
  },
  TOO_FAR: {
    title: "too_far_title",
    description: "too_far_description",
    imgSource: [TOO_FAR, TOO_FAR_CORRECT, TOO_FAR_WRONG],
    actualText: "Good View",
    distortedImgText: "Too Far",
  },
  UNSUPORTED_MEDIA_FILE: {
    title: "unsupported_media_file_title",
    description: "unsupported_media_file_description",
    imgSource: [UNSUPORTED_MEDIA_FILE],
  },
  SOMETHING_WENT_WRONG: {
    title: "something_went_wrong_title",
    description: "something_went_wrong_description",
    imgSource: [SOMETHING_WENT_WRONG],
  },
  HEALTHY_CROP: {
    title: "healthy_crop_title",
    description: "healthy_crop_description",
    imgSource: [HEALTHY_CROP],
  },
};

export const apiToModalType: Record<string, ModalType> = {
  image_blurry: "IMAGE_BLURRY",
  distance_too_far: "TOO_FAR",
  not_a_plant: "NOT_A_PLANT",
  crop_not_supported: "CROP_NOT_SUPPORTED",
  ornamental_plant: "ORNAMENTAL",
  unknown_disease: "UNKNOWN_DISEASE",
  unsupported_media_file: "UNSUPORTED_MEDIA_FILE",
  something_went_wrong: "SOMETHING_WENT_WRONG",
  healthy_crop: "HEALTHY_CROP",
};
